import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './PolicyPages.css';
import { Link } from 'react-router-dom';

const CancellationRefundsPolicy = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-container" data-aos="fade-up">
      <header className="policy-header" data-aos="fade-down">
        <h1>Cancellation & Refunds Policy</h1>
        <p>Last updated: November 27, 2025</p>
      </header>

      <section className="policy-section" data-aos="fade-right">
        <h2>1. Order Cancellation</h2>
        <p>You may cancel your order within 24 hours of placing it, provided it has not already been dispatched. To cancel your order, please <Link to="/contact">contact our customer support team</Link> with your order details as soon as possible.</p>
      </section>

      <section className="policy-section" data-aos="fade-left">
        <h2>2. Return Policy</h2>
        <p>We want you to be happy with your purchase. If you are not satisfied with a product, you can request a return. Please contact us to initiate the return process. Our team will guide you through the necessary steps.</p>
        <p>To be eligible for a return, the item must be unused, in the same condition that you received it, and in its original packaging with all tags intact.</p>
      </section>

      <section className="policy-section" data-aos="fade-right">
        <h2>3. Refund Process</h2>
        <p>Once we receive the returned product at our facility, it will be inspected to ensure it meets our return eligibility criteria. After a successful inspection, we will process your refund.</p>
        <p>The refund will be credited to your original method of payment within 7-10 business days. You will receive a notification once the refund has been initiated.</p>
      </section>

      <section className="policy-section" data-aos="fade-left">
        <h2>4. Non-Refundable Items</h2>
        <p>Certain items, such as those on final sale or customized products, may not be eligible for a refund. Any such exceptions will be clearly mentioned on the product page.</p>
      </section>

      <section className="policy-section" data-aos="fade-up">
        <h2>5. Contact Us</h2>
        <p>If you have any questions about cancellations or refunds, please <Link to="/contact">contact us</Link>. We are here to help.</p>
      </section>
    </div>
  );
};

export default CancellationRefundsPolicy;
